module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-10-19 at 7.26.10 PM.7c9932f9.png";